<template>
    <div>
        <div class="content">
            <div class="cont-list">
                <span class="list">{{
                    this.parentRoute.menuName + "-" + this.route.menuName
                    }}</span>
                <span class="masge">当前共有{{ total }}个{{ this.route.menuName }}</span>
            </div>
            <div class="header">
                <div class="left">
                    <!-- <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">
            删除
          </el-button> -->
                    <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary"
                        @click="exportData" v-loading="exportButtonLoading"
                        :disabled="exportButtonLoading">导出</el-button>
                    <BatchApproval v-if="tableAcl.indexOf('BatchApproves') != -1"
                        :multipleSelectionList="multipleSelection" :batchApproval="batchApproval" @getData="getData"
                        @reset="reset" />

                    <el-dropdown @command="mergePrint">
                        <el-button class="btn primary" type="primary">
                            打印
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="0">打印</el-dropdown-item>
                            <el-dropdown-item command="1">预览</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>

                    <SelectFilter ref="selectFilter" :options="filterOptions" :query="query"
                        @filterChange="filterChange" @reset="reset"></SelectFilter>
                </div>
                <div class="right">
                    <el-button class="btn primary" type="primary" style="margin-right: 10px"
                    @click="showTransfer">自定义设置</el-button>
                    <div class="search">
                        <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
                            <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
                        </el-input>
                    </div>
                    <span v-preventReClick @click="reset">重置</span>
                </div>
            </div>
            <el-tabs v-model="query.adjustPriceMode" @tab-click="handleClick">
                <el-tab-pane label="全部" name="2"></el-tab-pane>
                <el-tab-pane label="主动调价" name="0"></el-tab-pane>
                <el-tab-pane label="确认调价" name="1"></el-tab-pane>
            </el-tabs>

            <div v-if="tableHaeder.length>0">
                <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
                @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
                  <template slot="before">
                    <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
                    </el-table-column>
                  </template>
                  <template slot="after">
                    <el-table-column prop="operation" fixed="right" label="操作" width="180">
                        <template slot-scope="scope">
                            <el-button type="text" v-preventReClick @click="handleInfo(scope.row)"
                                class="color-blue">查看</el-button>
                            <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)"
                                type="text" v-preventReClick @click="handleApprove(scope.row)"
                                class="margin-left20 color-blue">审核</el-button>
                            <!-- <el-button v-else-if="
                    scope.row.status != 1 &&
                      scope.row.status != 2 &&
                      tableAcl.indexOf('Edit') != -1
                  " type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button> -->
                            <!-- <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="handleUpdate(scope.row)" class="color-blue">编辑</el-button> -->
                            <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status == 0" type="text"
                                v-preventReClick @click="handleDelete(scope.row)"
                                class="margin-left20 color-blue">删除</el-button>
                        </template>
                    </el-table-column>
                  </template>
                </CustomTable>
              </div>
             <div v-else>
                <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData"
                :max-height="tableHeight" style="width: 100%; margin-top: 10px"
                @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
                <template slot="empty">
                    <div class="empty-div" :style="{ height: tableHeight + 'px' }">
                        <img src="../../../../assets/noData.png" width="240" height="240" />
                        <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
                        <div class="empty-rest" @click="reset">恢复默认</div>
                    </div>
                </template>
                <el-table-column fixed :reserve-selection="true" type="selection" width="55"
                    align="center"></el-table-column>
                <el-table-column width="100" label="调价方式">
                    <template slot-scope="scope">
                        {{ scope.row.adjustPriceMode == 0 ? "主动调价" : "确认调价" }}
                    </template>
                </el-table-column>
                <el-table-column prop="onlineNo" min-width="180" label="供应商产品编码"></el-table-column>
                <el-table-column prop="productCode" min-width="120" label="商品代码"></el-table-column>
                <el-table-column prop="supplierName" min-width="160" label="供应商">
                    <template slot-scope="scope">
                        {{ scope.row.supplierName?scope.row.supplierName:'-' }}
                    </template>
                </el-table-column>
                <el-table-column prop="productName" min-width="160" show-overflow-tooltip
                    label="产品名称"></el-table-column>
                <el-table-column prop="specName" min-width="160" show-overflow-tooltip label="规格型号"></el-table-column>
                <el-table-column prop="manufacturerName" min-width="160" show-overflow-tooltip
                    label="生产厂家"></el-table-column>
                <el-table-column prop="purchasePrice" width="80" label="新采购价"></el-table-column>
                <el-table-column prop="billingPrice" width="80" label="新计费价"></el-table-column>
                <el-table-column prop="onlinePrice" width="80" label="新挂网价"></el-table-column>
                <el-table-column prop="oldPurchasePrice" width="80" label="原采购价"></el-table-column>
                <el-table-column prop="oldBillingPrice" width="90" label="原计费价"></el-table-column>
                <el-table-column prop="oldOnlinePrice" width="80" label="原挂网价"></el-table-column>
                <el-table-column prop="profitAndLossTotalAmount" width="80" label="损益金额">
                    <template slot-scope="scope">
                        {{ scope.row.profitAndLossTotalAmount?scope.row.profitAndLossTotalAmount:'-' }}
                    </template>
                </el-table-column>
                <el-table-column prop="profitAndLossTotalNumber" width="80" label="损益数量">
                    <template slot-scope="scope">
                        {{ scope.row.profitAndLossTotalNumber?scope.row.profitAndLossTotalNumber:'-' }}
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="100" label="创建人">
                    <template slot-scope="scope">
                        {{ scope.row.adjustPriceMode == 1 ? "-" : scope.row.createdUserName }}
                    </template>
                </el-table-column>
                <el-table-column prop="createdTime" label="创建时间" show-overflow-tooltip min-width="180">
                    <template slot-scope="scope">
                        {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
                    </template>
                </el-table-column>
                <el-table-column v-if="isWorkflowTable" label="审批人" width="100" align="center" prop="approverNames">
                    <template slot-scope="scope">
                        {{ scope.row.approverNames?scope.row.approverNames:'-' }}
                    </template>
                </el-table-column>
                <el-table-column prop="statusName" label="流程状态" width="100" v-if="isWorkflowTable">
                    <template slot-scope="scope">
                        <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable"
                            :options="ApproveStatusOptions" @success="getData" :tableCode="route.name"></approve-status>
                    </template>
                </el-table-column>

                <el-table-column prop="operation" fixed="right" label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button type="text" v-preventReClick @click="handleInfo(scope.row)"
                            class="color-blue">查看</el-button>
                        <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)"
                            type="text" v-preventReClick @click="handleApprove(scope.row)"
                            class="margin-left20 color-blue">审核</el-button>
                        <!-- <el-button v-else-if="
                scope.row.status != 1 &&
                  scope.row.status != 2 &&
                  tableAcl.indexOf('Edit') != -1
              " type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button> -->
                        <!-- <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="handleUpdate(scope.row)" class="color-blue">编辑</el-button> -->
                        <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status == 0" type="text"
                            v-preventReClick @click="handleDelete(scope.row)"
                            class="margin-left20 color-blue">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            </div>
          

            <el-dialog :title="title + route.menuName" :visible.sync="open" :center="true" width="900px"
                :before-close="cancel" :close-on-click-modal="false">
                <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="调价类型">
                                <el-input :disabled="!editMode" v-model="form.adjustPriceTypeName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="商品代码">
                                <el-input :disabled="!editMode" v-model="form.productCode"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="供应商产品编码">
                                <el-input :disabled="!editMode" v-model="form.onlineNo"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="产品名称">
                                <el-input :disabled="!editMode" v-model="form.productName"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="规格型号">
                                <el-input :disabled="!editMode" v-model="form.specName"></el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item label="生产厂家">
                                <el-input :disabled="!editMode" v-model="form.manufacturerName"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="原采购价">
                                <el-input disabled type="number" v-model="form.oldPurchasePrice"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="原计费价">
                                <el-input disabled type="number" v-model="form.oldBillingPrice"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="原挂网价">
                                <el-input disabled type="number" v-model="form.oldOnlinePrice"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item prop="isUpdateProduct" label="是否更新目录价格">
                                <el-select v-model="form.isUpdateProduct" :disabled="approve1 && !editMode"
                                    placeholder="请选择">
                                    <el-option v-for="item in isUpdateProductOptions" :key="item.id" :label="item.name"
                                        :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item prop="purchasePrice" label="新采购价">
                                <el-input :disabled="!editMode" type="number" v-model="form.purchasePrice"
                                    placeholder="请输入采购价"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item prop="billingPrice" label="新计费价">
                                <el-input :disabled="!editMode" type="number" v-model="form.billingPrice"
                                    placeholder="请输入计费价"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item prop="onlinePrice" label="新挂网价">
                                <el-input :disabled="!editMode" type="number" v-model="form.onlinePrice"
                                    placeholder="请输入挂网价"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item prop="isUpdateStock" label="是否更新库存表">
                                <el-select v-model="form.isUpdateStock" :disabled="approve1 && !editMode"
                                    placeholder="请选择">
                                    <el-option v-for="item in UpdateStockType" :key="item.id" :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- <el-row>

          </el-row> -->
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="备注">
                                <el-input :disabled="!editMode" v-model="form.remark"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="18">
                            <el-form-item label="附件">
                                <UploadFileList :fileList="form.fileInfos" btnShowType="always" :editMode="editMode"
                                    @fileChange="fileChange" :showLabel="false"></UploadFileList>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="创建人">
                                <el-input disabled v-model="form.createdUserName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <!-- <el-input disabled v-model="form.createdTime"></el-input>  -->
                            <el-form-item label="创建时间" prop="createdTime">
                                <el-date-picker v-model="form.createdTime" disabled type="datetime"
                                    placeholder="系统自动带出创建时间" style="width: 100%">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
                    <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确
                        定</my-button>
                    <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick
                        @click="approve">确
                        定</my-button>
                    <el-button v-if="!editMode" class="btn default" v-preventReClick @click="open = false">返
                        回</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="pagination">
            <el-pagination background layout="sizes, prev, pager, next, jumper"
                :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize"
                @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total"
                @current-change="changePage">
            </el-pagination>
        </div>
        <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
    </div>
</template>

<script>
import {
    RejectProductPriceUpdate,
    GetProductPriceUpdates,
    RemoveProductPriceUpdate,
    GetProductPriceUpdateById,
    SaveProductPriceUpdate,
    ExportProductPriceUpdate,
    ApproveProductsPriceUpdate,
    GetProductPriceUpdatePrintData,
    CheckProductEnableState,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import BaseListMixin from "@/mixin/baseList-mixin.js";
import SelectTree from "@/components/select-tree";
import UploadFileList from "@/components/upload-file-list";
import {
    WhetherOptions,
    ProductionPlaceOptions,
    AdjustPriceType,
    UpdateStockType,
    ApproveStatusOptions,
    AdjustPriceTypeOptions,
    isUpdateProductOptions,
} from "@/enum";
import ApproveInfo from "@/components/approve-info";
import SelectFilter from "@/components/table-select-filter";
import BatchApproval from "@/components/batchApproval";
export default {
    mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
    components: {
        SelectTree,
        UploadFileList,
        ApproveInfo,
        SelectFilter,
        BatchApproval,
    },
    data() {
        return {
            ApproveStatusOptions: ApproveStatusOptions,
            exportAction: ExportProductPriceUpdate,
            AdjustPriceTypeOptions: AdjustPriceTypeOptions,
            batchApproval: ApproveProductsPriceUpdate,
            MergePrintAction: GetProductPriceUpdatePrintData,
            // 查询条件
            query: {
                keyWord: "",
                pageSize: 10,
                pageIndex: 1,
                adjustPriceMode: "2",
                adjustPriceType: 2,
            },
            editMode: false,
            // 列表数据
            tableData: [],
            // 列表总数
            total: 0,
            // 弹出框标题
            title: "",
            // 弹出编辑框
            open: false,
            // 新增、编辑的数据
            form: {},
            // 多选框数据
            ids: [],
            multipleSelection: [],
            // 列表多选
            multiple: true,
            rules: {},
            filterOptions: [
                {
                    name: "产品名称",
                    type: "input",
                    code: "productName",
                },
                // {
                //   name: "供应商",
                //   type: "input",
                //   code: "supplierName",
                // },
                {
                    name: "规格型号",
                    type: "input",
                    code: "specName",
                },
                {
                    name: "生产厂家",
                    type: "select",
                    code: "manufacturerId",
                    filterMethod: this.getManufacturers,
                    data: [],
                },
                {
                    name: "创建日期",
                    type: "date",
                    code: "date",
                },
                {
                    name: "创建人",
                    type: "select",
                    code: "createdUserId",
                    filterMethod: this.getUsers,
                    data: [],
                },
                // {
                //     name: "供应商产品编码|商品代码",
                //     type: "input",
                //     code: "keyWord",
                // },
                {
                    name: "供应商产品编码",
                    type: "input",
                    code: "keyWord",
                },
                {
                    name: "商品代码",
                    type: "input",
                    code: "productCode",
                },
                {
                    name: "流程状态",
                    type: "select",
                    code: "statuses",
                    multiple: true,
                    data: ApproveStatusOptions,
                },

                {
                    name: "供应商",
                    type: "select",
                    code: "supplierId",
                    filterMethod: this.getSuppliers,
                    data: [],
                },
                {
                    name: "调价类型",
                    type: "select",
                    code: "adjustPriceType",
                    data: AdjustPriceTypeOptions,
                },
                {
                    name: "新采购价",
                    type: "numberRange",
                    startCode: "minNewPrice",
                    endCode: "maxNewPrice",
                },
            ],
            defaultProps: {
                children: "childs",
                label: "name",
            },
            approve1: false,
            WhetherOptions: WhetherOptions,
            AdjustPriceType: AdjustPriceType,
            UpdateStockType: UpdateStockType,
            ProductionPlaceOptions: ProductionPlaceOptions,
            isUpdateProductOptions:isUpdateProductOptions,
            certForm: {},
            openCertDialog: false,
            reject: RejectProductPriceUpdate,
        };
    },
    methods: {
        handleClick(val, tab) {
            this.query.adjustPriceMode = val.name;
            this.getData();
        },
        handleSelectionChange(selection) {
            this.multipleSelection = selection;
            this.ids = selection.map((item) => item.id);
            this.multiple = !selection.length;
        },
        // 重置
        reset() {
            this.query = {
                keyWord: "",
                pageSize: 10,
                pageIndex: 1,
                orgCode :sessionStorage.getItem('orgId')
            };
            if (this.$refs["selectFilter"]) {
                this.$refs["selectFilter"].resetQuery();
            }
            // this.ids = []
            // this.multipleSelection = []
            // this.multiple = true;

            // if (this.$refs.multipleTable) {
            //   this.$refs.multipleTable.clearSelection()
            // }
            console.log(this.query, "query");
            this.getData();
        },
        // 获取列表
        getData() {
            this.loading = true;
            GetProductPriceUpdates(this.query)
                .then((res) => {
                    this.tableData = res.returnData.data;
                    this.total = res.returnData.totalCount;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 新建
        handleAdd() {
            this.open = true;
            this.title = "新建";
            this.resetForm();
            this.editMode = true;
            this.showWorkFlowInfo = false;
        },

        handleInfo(row) {
            GetProductPriceUpdateById({
                id: row.id,
            }).then((res) => {
                this.resetForm();
                this.form = res.returnData;
                this.open = true;
                this.approve1 = true;
                this.editMode = false;
                this.title = "查看";

                this.initWorkFlowProperty(this.form);
            });
        },
        // 编辑
        handleUpdate(row) {
            GetProductPriceUpdateById({
                id: row.id,
            }).then((res) => {
                this.resetForm();
                this.form = res.returnData;
                this.open = true;
                this.editMode = true;
                this.title = "编辑";

                this.initWorkFlowProperty(this.form);
            });
        },
        handleApprove(row) {
            this.showWorkFlowInfo = false;

            GetProductPriceUpdateById({
                id: row.id,
            }).then((res) => {
                this.resetForm();
                this.form = res.returnData;
                this.open = true;
                this.editMode = false;
                this.approve1 = false;
                this.title = "审批";
                this.showWorkFlowInfo = this.isShowApproveButton(this.form.approverIds);
                this.form.result = 1; // 处理审批变拒绝
            });
        },
        // 保存
        submit() {
            this.$refs["form"].validate((valid) => {
                if (!valid) {
                    return false;
                }

                    SaveProductPriceUpdate(this.form)
                        .then((res) => {
                            this.open = false;
                            this.form.result = "";
                            this.$my_message(`执行成功`, "success");
                            this.getData();
                        })
                        .then(() => {
                            // // 返回指定页
                            // this.$router.push({
                            //   name: "ProductPriceUpdateOpeartion",
                            // });
                        })
                        .finally(() => {
                            this.$store.dispatch("SetLoading", false);
                        });
              
            });
        },
        resetForm() {
            this.form = {
                id: 0,
                no: "",
                createdUserName: this.userInfo.name,
                createdTime: this.parseTime(new Date()),
                productCode: "",
                supplierProductIds: "",
                oldPurchasePrice: 0,
                oldOnlinePrice: 0,
                oldBillingPrice: 0,
                adjustPriceType: 2,
                orgCode :sessionStorage.getItem('orgId')
            };
        },
        // 取消编辑
        cancel() {
            if (this.editMode) {
                this.$my_confirm("确认要中断当前操作吗？", "提示", {
                    type: "warning",
                })
                    .then(() => {
                        this.open = false;
                        // 返回指定页
                        this.$router.push({
                            name: "ProductPriceUpdateOpeartion",
                            // params: { backAppointPage: 1 }
                        });
                    })
                    .catch(() => { });
            } else {
                this.open = false;
            }
        },
        // 改变当前页
        changePage(val) {
            this.$set(this.query, "pageIndex", val);
            this.getData();
        },
        handleSizeChange(val) {
            this.$set(this.query, "pageSize", val);
            this.getData();
        },

        // 删除部门
        handleDelete(row) {
            const ids = row && row.id ? [row.id] : this.ids;

            this.$my_confirm("此操作将删除数据, 是否继续?", "提示", {
                type: "warning",
            })
                .then(() => {
                    return RemoveProductPriceUpdate({
                        ids,
                    });
                })
                .then(() => {
                    this.$my_message(`删除成功`, "success");
                    this.getData();
                })
                .catch(() => { });
        },
        // 重置
        // reset () {
        //   this.query.keyWord = "";
        //   this.$set(this.query, "pageIndex", 1);
        //   this.$set(this.query, "pageSize", 10);
        //   this.ids = []
        //   this.multipleSelection = []
        //   this.multiple = true;

        //   if (this.$refs.multipleTable) {
        //     this.$refs.multipleTable.clearSelection()
        //   }
        //   this.getData();
        // },
        queryChange() {
            this.$set(this.query, "pageIndex", 1);
            this.getData();
        },

        // 上传附件
        // filesChange(fileList) {
        //   this.form.fileInfos = fileList;
        // },
        fileChange(e) {
            this.form.fileInfos = e;
        },
    },
    mounted() {
        if (
            this.$route.query &&
            (this.$route.query.formMode == 3 || this.$route.query.formMode == 0)
        ) {
            this.query.id = this.$route.query.id;
            this.handleInfo({
                id: this.$route.query.id,
            });
        }
        this.getData();
        this.getProductCategorys("");
        this.getProductRegistCerts("");
        this.getManageRanges("");
        this.getSpecs("");
    },
    watch: {},
    created() {
        this.getManufacturers("");
        this.getUsers("");
    },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
    overflow-y: auto !important;
}
</style>
